var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/TopNav/TopNav.jinja"] = require( "front/components/TopNav/TopNav.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Career/Career.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/Career/Career.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Career/Career.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("macros", t_4);
output += "\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Career/Career.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "svgSprite")) {
var t_10 = t_7.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_10);
output += "\n";
env.getTemplate("front/components/TopNav/TopNav.jinja", false, "assets/app/front/pages/Career/Career.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "TopNav")) {
var t_14 = t_11.TopNav;
} else {
cb(new Error("cannot import 'TopNav'")); return;
}
context.setVariable("TopNav", t_14);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("ogtitle"))(env, context, frame, runtime, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
output += t_17;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("topNav"))(env, context, frame, runtime, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
output += t_19;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_22,t_21) {
if(t_22) { cb(t_22); return; }
output += t_21;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += " • ";
output += runtime.suppressValue((lineno = 5, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Карьера"])), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_ogtitle(env, context, frame, runtime, cb) {
var lineno = 6;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += " • ";
output += runtime.suppressValue((lineno = 6, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Карьера"])), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_topNav(env, context, frame, runtime, cb) {
var lineno = 8;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n";
output += runtime.suppressValue((lineno = 9, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "TopNav"), "TopNav", context, [runtime.makeKeywordArgs({"classes": "TopNav--fixed"})])), env.opts.autoescape);
output += "\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 12;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n<div class=\"Career\">\n    <div class=\"Career-floatNav\"></div>\n    <div class=\"Career-bg\">\n        <picture>\n            <source srcset=\"/static/img/front/career/bg.png 1x, /static/img/front/career/bg@2x.png 2x\" media=\"(min-width: 768px)\" />\n            <img\n                class=\"Career-bgImage\"\n                src=\"/static/img/front/career/bg-mobile.png\"\n                srcset=\"/static/img/front/career/bg-mobile.png 1x, /static/img/front/career/bg-mobile@2x.png 2x\"\n                alt=\"\"\n                decoding=\"async\"\n            />\n        </picture>\n    </div>\n    <div class=\"Career-main\">\n        <div class=\"Career-header\">\n            <div class=\"Career-subtitle\">\n                <span class=\"Career-subtitleStroke\"></span>\n                <div class=\"Career-subtitleText\">";
output += runtime.suppressValue((lineno = 31, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Карьера"])), env.opts.autoescape);
output += "</div>\n            </div>\n            <h1 class=\"Career-title\">\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"title"), env.opts.autoescape);
output += "\n            </h1>\n            <div class=\"Career-text\">\n                <p>";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"description")), env.opts.autoescape);
output += "</p>\n            </div>\n        </div>\n        <div class=\"Career-container\">\n            ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"advantages")) > 0) {
output += "<section class=\"Career-section\">\n                <h2 class=\"Career-sectionTitle\">Что мы предлагаем нашим сотрудникам</h2>\n                <div class=\"CareerAdvantages\">\n                    ";
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"advantages");
if(t_25) {t_25 = runtime.fromIterator(t_25);
var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("item", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") < (env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"advantages")) - 1)) {
output += "\n                        <div class=\"CareerAdvantages-item\">\n                            ";
if(runtime.memberLookup((t_26),"text")) {
output += "\n                            <h3 class=\"CareerAdvantages-itemTitle\">";
output += runtime.suppressValue(runtime.memberLookup((t_26),"text"), env.opts.autoescape);
output += "</h3>\n                            ";
;
}
output += "\n\n                            ";
if(runtime.memberLookup((t_26),"img")) {
output += "\n                            <div class=\"CareerAdvantages-itemImage\">\n                                <img\n                                    src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"img")),"w1280"), env.opts.autoescape);
output += "\"\n                                    srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"img")),"w640"), env.opts.autoescape);
output += " 640vw,\n                                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"img")),"w768"), env.opts.autoescape);
output += " 768vw,\n                                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"img")),"w1024"), env.opts.autoescape);
output += " 1024vw,\n                                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"img")),"w1280"), env.opts.autoescape);
output += " 1280vw,\n                                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"img")),"w1440"), env.opts.autoescape);
output += " 1440vw,\n                                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_26),"img")),"w1920"), env.opts.autoescape);
output += " 1920vw\"\n                                    alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_26),"text"), env.opts.autoescape);
output += "\"\n                                    decoding=\"async\"\n                                >\n                            </div>\n                            ";
;
}
output += "\n                        </div>\n                        ";
;
}
output += "\n                    ";
;
}
}
frame = frame.pop();
output += "</div>\n\n                <div class=\"CareerAdvantageMain\">\n                    <div class=\"CareerAdvantageMain-text\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"value")), env.opts.autoescape);
output += "\n                    </div>\n                    ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"advantages")) > 0) {
output += "\n                    <div class=\"CareerAdvantageMain-img\">\n                        ";
var t_27;
t_27 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"advantages")),env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "careerPage")),"advantages")) - 1);
frame.set("commonImg", t_27, true);
if(frame.topLevel) {
context.setVariable("commonImg", t_27);
}
if(frame.topLevel) {
context.addExport("commonImg", t_27);
}
output += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "commonImg")) {
output += "\n                        <img\n                            src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "commonImg")),"img")),"w1280"), env.opts.autoescape);
output += "\"\n                            srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "commonImg")),"img")),"w640"), env.opts.autoescape);
output += " 640vw,\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "commonImg")),"img")),"w768"), env.opts.autoescape);
output += " 768vw,\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "commonImg")),"img")),"w1024"), env.opts.autoescape);
output += " 1024vw,\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "commonImg")),"img")),"w1280"), env.opts.autoescape);
output += " 1280vw,\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "commonImg")),"img")),"w1440"), env.opts.autoescape);
output += " 1440vw,\n                                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "commonImg")),"img")),"w1920"), env.opts.autoescape);
output += " 1920vw\"\n                            alt=\"\"\n                            decoding=\"async\"\n                        >\n                        ";
;
}
output += "\n                    </div>\n                    ";
;
}
output += "\n                </div>\n            </section>\n            ";
;
}
output += "\n\n            ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "careerDirections")) > 0) {
output += "<section class=\"Career-section\" id=\"vacancies\">\n                <h2 class=\"Career-sectionTitle\">Вакансии</h2>\n                <ul class=\"CareerDirections CareerDirections--main\">\n                    ";
frame = frame.push();
var t_30 = runtime.contextOrFrameLookup(context, frame, "careerDirections");
if(t_30) {t_30 = runtime.fromIterator(t_30);
var t_29 = t_30.length;
for(var t_28=0; t_28 < t_30.length; t_28++) {
var t_31 = t_30[t_28];
frame.set("item", t_31);
frame.set("loop.index", t_28 + 1);
frame.set("loop.index0", t_28);
frame.set("loop.revindex", t_29 - t_28);
frame.set("loop.revindex0", t_29 - t_28 - 1);
frame.set("loop.first", t_28 === 0);
frame.set("loop.last", t_28 === t_29 - 1);
frame.set("loop.length", t_29);
output += "<li class=\"CareerDirections-item\">\n                        <a class=\"CareerDirections-itemLink\" href=\"/career/";
output += runtime.suppressValue(runtime.memberLookup((t_31),"slug"), env.opts.autoescape);
output += "\">\n                            <div class=\"CareerDirections-itemBg\">\n                                <img\n                                    src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_31),"img")),"w370"), env.opts.autoescape);
output += "\"\n                                    srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_31),"img")),"w370"), env.opts.autoescape);
output += " 1x, ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_31),"img")),"w768"), env.opts.autoescape);
output += " 2x\"\n                                    alt=\"";
output += runtime.suppressValue(runtime.memberLookup((t_31),"slug"), env.opts.autoescape);
output += "\"\n                                    loading=\"lazy\"\n                                    decoding=\"async\"\n                                >\n                            </div>\n                            <h3 class=\"CareerDirections-itemTitle\">";
output += runtime.suppressValue(runtime.memberLookup((t_31),"name"), env.opts.autoescape);
output += "</h3>\n                        </a>\n                    </li>\n                    ";
;
}
}
frame = frame.pop();
output += "</ul>\n            </section>\n            ";
;
}
output += "\n        </div>\n    </div>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_ogtitle: b_ogtitle,
b_topNav: b_topNav,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Career/Career.jinja"] , dependencies)